var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-label": "GraphQL",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#e10098",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 8l20.8 12v24L32 56 11.2 44V20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 8l20.8 36H11.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e10098"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 8,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.8,
    cy: 20,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.8,
    cy: 44,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 56,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2,
    cy: 44,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.2,
    cy: 20,
    r: 4.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphql);
export default __webpack_public_path__ + "static/media/graphql.08fbd158f08342a19d29684eba85fdb0.svg";
export { ForwardRef as ReactComponent };